import { Router } from 'vue-router'
import { App } from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import { Integration, Options } from '@sentry/types'

import { logInfo } from '@/shared/logger'
import { LUKSO_MAINNET_ID } from '@/shared/NetworkUtils'

interface SentryOptions extends Options {
  app?: App
  router?: Router
  tracingOptions?: {
    trackComponents: boolean
  }
  logErrors?: boolean
  attachProps?: boolean
}

const configs: (router?: Router) => SentryOptions = router => ({
  integrations:
    router &&
    ([
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ] as Integration[]),
  tracingOptions: {
    trackComponents: true,
  },
  logErrors: process.env.NODE_ENV !== 'production',
  attachProps: true,
  attachStacktrace: true,
})

const sharedConfig: SentryOptions = {
  dsn: process.env.VUE_APP_SENTRY_DSN,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1,
  debug: false,
  environment: process.env.NODE_ENV,
  release: process.env.RELEASE,
}

export const initSentry = (options?: SentryOptions): void => {
  if (process.env.VUE_APP_SENTRY_ENABLED === 'true') {
    if (!process.env.VUE_APP_SENTRY_DSN) {
      logInfo('Sentry init: failure. Ngit sto VUE_APP_SENTRY_DSN specified')
      return
    }
    const config = {
      ...sharedConfig,
      ...configs(options?.router),
      ...options,
      beforeSend(event: any) {
        const currentScope = Sentry.getCurrentHub().getScope() as any
        const networkId = currentScope?._tags?.networkId
        if (
          networkId === LUKSO_MAINNET_ID ||
          /resizeobserver loop/i.test(event?.message || '')
        ) {
          logInfo(`silenced ${event.message}`)
          // eslint-disable-next-line unicorn/no-null
          return null
        }
        return event
      },
    }
    Sentry.init(config)
    logInfo(`Sentry init: success. ENV: ${process.env.NODE_ENV}`)
  } else {
    logInfo('Sentry init: failure. VUE_APP_SENTRY_ENABLED is not set to `true`')
  }
}
